import { useCatalog } from '../../_index/hooks/useCatalog';

export interface CatalogSummary {
  /** 완료(DONE) 공통 코드 수. 로딩/에러 시 null(뱃지 생략 — graceful degrade) */
  completedCount: number | null;
  isLoading: boolean;
  isError: boolean;
}

/**
 * §5.1 (선택) 재사용 — 기존 GET /api/eraf/biz/catalog(=_index 소유) 를 그대로 소비해
 * "완료 공통 코드 수" 만 파생한다. 신규 엔드포인트/DTO 없음.
 * 실패해도 페이지 전체는 정상 — 딥링크 카드의 뱃지만 생략된다(§6.8).
 */
export function useCatalogSummary(): CatalogSummary {
  const { data, isLoading, isError } = useCatalog();
  const completedCount =
    !isLoading && !isError && data
      ? data.commonFeatures.filter((f) => f.status === 'DONE').length
      : null;

  return { completedCount, isLoading, isError };
}
